import React from 'react';
import { Instagram, Mail, ArrowUp, Phone, MapPin } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { Button } from './ui/button';
import { mockData } from '../data/mock';
import { ShareButtons } from './ShareButtons';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const el = window.location.pathname === '/' ? document.getElementById(sectionId) : null;
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else window.location.assign(`/#${sectionId}`);
  };

  return (
    <footer className="bg-gray-900 text-white relative">
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        aria-label="Volver arriba" data-testid="scroll-top-btn" className="absolute -top-6 right-4 sm:right-8 w-12 h-12 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110"
      >
        <ArrowUp className="w-6 h-6 text-white" />
      </button>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
        <div className="grid md:grid-cols-2 gap-8 mb-8 sm:mb-12">
          {/* About */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img 
                  src="/img/logo-uiq.webp" 
                  alt="Logo UIQ"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <h3 className="font-bold text-lg">Unión Industrial Quilmes</h3>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Fortaleciendo la industria de Quilmes desde hace más de 50 años.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${mockData.contact.email}`} className="text-gray-400 hover:text-blue-400 transition-colors break-all">
                  {mockData.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <a href={`tel:${mockData.contact.phoneLink}`} className="text-gray-400 hover:text-blue-400 transition-colors">{mockData.contact.phone}</a>
              </li>
              <li className="flex items-start space-x-2">
                <WhatsAppIcon className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <a 
                  href="https://wa.me/5491130295481" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  +54 11-3029-5481
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">{mockData.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Social Media + Share */}
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              <div className="flex items-center space-x-3">
                <span className="text-gray-400 text-sm">Seguinos:</span>
                <a 
                  href="https://www.instagram.com/unionindustrialquilmes/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Instagram de UIQ"
                  className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://www.instagram.com/unionindustrialquilmes/', '_blank', 'noopener,noreferrer');
                  }}
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-gray-400 text-sm">Compartí el sitio:</span>
                <ShareButtons dark />
              </div>
            </div>

            {/* Copyright */}
            <div className="text-center md:text-right">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Unión Industrial Quilmes. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
